import React from 'react';
import { withPrefix } from 'gatsby';
import styles from './SponsorBar.styles';

const SponsorBar = ({ logoHeader }) => (
  <div css={styles}>
    <div className="sponsor-bar">
      <div className="sponsor-bar__container">
        <p className="sponsor-bar__text">Advertisement feature</p>
      </div>
      {logoHeader && <img src={withPrefix(logoHeader)} alt="logoWework" className="logo-header" />}
    </div>
  </div>
);

export default SponsorBar;
